module.exports = __webpack_public_path__ + "img/first-day-1.e86c4449.png";